<article
  class="flex items-center gap-4 rounded-xl border bg-lGray900 px-4 py-4 transition-colors duration-200"
  [ngClass]="{
    'border-dashed pointer-events-none opacity-50 border-lGray60': ghost,
    'shadow-soft-black border-lGray60': preview,
    'border-lGray700': !ghost && !preview
  }"
>
  @if (ghost) {
    <span
      class="flex shrink-0 items-center justify-center text-lGray600 opacity-0"
      aria-hidden="true"
    >
      <l-icon class="text-2xl">menu</l-icon>
    </span>
  } @else {
    <button
      type="button"
      cdkDragHandle
      class="flex shrink-0 cursor-grab touch-none items-center justify-center text-lGray600 transition-colors active:cursor-grabbing"
      aria-label="Reordenar módulo"
    >
      <l-icon class="text-2xl">menu</l-icon>
    </button>
  }

  <div class="flex min-w-0 flex-1 flex-col gap-2">
    <div class="flex items-center gap-2">
      <l-icon class="text-base text-lGray500">deployed_code</l-icon>
      <span class="text-sm font-medium text-lGray50">Módulo {{ moduleIndex }}</span>
    </div>

    <input
      type="text"
      class="h-12 w-full rounded-xl border-0 bg-lGray950 px-4 text-base text-lGray50 outline-none transition-colors duration-200 placeholder:text-lGray600 focus:bg-lGray700"
      [ngModel]="name"
      (ngModelChange)="onNameChange($event)"
      [readonly]="ghost"
      [tabindex]="ghost ? -1 : 0"
      [attr.aria-label]="'Nome do módulo ' + moduleIndex"
      placeholder="Digite o nome do módulo"
    />
  </div>

  @if (showActivationToggle && !ghost) {
    <div class="flex shrink-0 items-center gap-3">
      <span class="inline-block w-20 shrink-0 text-right whitespace-nowrap text-sm text-lGray50">{{ activationLabel }}</span>

      <span class="relative inline-flex h-7 w-12 shrink-0">
        <input
          type="checkbox"
          class="absolute inset-0 z-10 h-full w-full cursor-pointer opacity-0"
          [checked]="isActive"
          [attr.aria-label]="activationLabel"
          (click)="onToggleActive($event)"
        />
        <span
          class="pointer-events-none absolute inset-0 rounded-full transition-colors duration-200"
          [ngClass]="{
            'bg-lPrimary': isActive,
            'bg-white': !isActive
          }"
        ></span>
        <span
          class="pointer-events-none absolute top-1 left-1 h-5 w-5 rounded-full transition-[transform,background-color] duration-200 will-change-transform"
          [ngClass]="{
            'translate-x-5 bg-white': isActive,
            'translate-x-0 bg-lPrimary': !isActive
          }"
        ></span>
      </span>
    </div>
  }

  <button
    type="button"
    class="flex shrink-0 items-center justify-center text-lDanger transition-opacity hover:opacity-80"
    [class.invisible]="ghost"
    [attr.aria-hidden]="ghost"
    [disabled]="ghost"
    aria-label="Excluir módulo"
    (click)="onDelete()"
  >
    <l-icon class="text-xl">delete</l-icon>
  </button>
</article>
